import { Link, Outlet, useLocation } from "react-router-dom"
import Dasboard from "../../../../../Components/Icons/Dasboard";
import { useEffect, useState } from "react";
import SearchBar from "../../../../../Components/Utils/SearchBar";
import { CreateButton, FilterButton } from "../../../../../Components/Utils/Buttons";
import { GetAccess } from "../../../../../Components/Utils/roles";
import Breadcrumb from "../../../../../Components/Utils/Breadcrumb";

const TaskLayout = (
    {
        SearchData=() => {},
        setSearchQuery=()=>{},
        CreateAccess= true,
        ImportAccess= true,
        setOpen=()=>{},
        children,
        isFilter=false,
        setFilterOpen=()=>{},
        ClearFilter=()=>{},
        setOpenImport=()=>{},
        officeId,
        projectId
    }
) =>{
    let {pathname} = useLocation()
    const [module,setModule] = useState("")
    
    useEffect(() =>{
        if(pathname == `/project/tasks/my-task/${officeId}/${projectId}`){
            setModule("My Task")
        }else if(pathname == `/project/tasks/all-task/${officeId}/${projectId}`){
            setModule("All Task")
        }
    },[pathname])

    let LinkItem = [
        {
            label:"My Task",
            link:`/project/tasks/my-task/${officeId}/${projectId}`,
            access:GetAccess(),
        },
        {
            label:"All Task",
            link:`/project/tasks/all-task/${officeId}/${projectId}`,
            access:GetAccess(),
        },
        
    ]
    
    return(
        <div className=" w-full h-full py-2 px-4 ">
            <div className="">
            <div className="md:flex justify-end w-full">
            {/* <Breadcrumb
          items={[
            {
                name: "Task",
              },
              {
                name: module,
              },

          ]}
        /> */}
        <div className=" w-full h-8 flex items-center gap-x-4 ">
            {
                LinkItem && LinkItem.map((item, i) => {
                    return(
                        <>
                         {
                            item.access && (
                                <Link to={item?.link} className={`mx-3 pb-1 text-xs 2xl:text-sm font-medium text-baseColor-primary ${item?.link == pathname ?"border-b-2 border-baseColor-primary":"border-b-2 border-transparent"}   `}  key={item?.link} >{item?.label||""}</Link>
                                // <Link to={item?.link} style={item?.link == pathname ?{borderBottom:"4px solid #119DEE"}:{borderBottom:"4px solid transparent"}} className={` pb-1 text-[13px] font-medium text-mainColor-400 hover:text-mainColor-400 ${item?.link == pathname ?"border-b-4 border-red":""}   `}  key={item?.link} >{item?.label||""}</Link>
                            )
                         }
                        </>
                    )
                })
            }
        </div>

            <div className=" flex justify-end items-center gap-3 mr-6">

             {
                (module == "Plan"|| module == "My Task"||module == "All Task") && (
                    <>
                                <form className="flex items-center gap-3 mx-0" onSubmit={SearchData}>
              <SearchBar handleChange={(e) => setSearchQuery(e.target.value)} />
              </form>
              <FilterButton label='Filter'  handleClick={()=>{setFilterOpen(true);setSearchQuery("");}} />
                    </>
                
            )
             }

              {isFilter&& <FilterButton label='Clear Filter'  handleClick={ClearFilter} />}
             
             {
                module == "Plan" && <>{ImportAccess && <CreateButton label="Import" handleClick={()=> setOpenImport(true)}     />}</>
             } 

             {
                module == "Plan" && <>{CreateAccess &&<CreateButton handleClick={()=>setOpen(true)} label={"Title"}/>}</> 
             }

             
            
                </div>
            </div>
           
            
            <div className=" mt-2 w-full h-[calc(100vh-180px)]">
               {children} 
            </div>
            </div>
        </div>
    )
}


export default TaskLayout;